import React, { Component } from 'react';
import * as d3 from 'd3';
import './scatter.css';

class ChartScatter extends Component {
	constructor(props) {
		super(props);
		
		this.viewbox = this.viewbox.bind( this );
		this.draw = this.draw.bind( this );
		this.findLineByLeastSquares = this.findLineByLeastSquares.bind(this);
		
		this.state = {
			"avg": {
				"x": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0
				},
				"y": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0
				}
			},
			"axis": {
				"x": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0,
					"label": {
						"x": 0,
						"y": 0
					}
				},
				"y": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0,
					"label": {
						"x": 0,
						"y": 0
					}
				}
			},
			"loading": false,
			"point_config": {
				"h": 15,
				"rx": 3,
				"ry": 3,
				"w": 15
			},
			"points": [],
			"regression": {
				"x1":0,
				"y1":0,
				"x2":0,
				"y2":0
			},
			"size": {
				"h": 200,
				"w": 400
			}
		}
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.DrawingData !== this.props.DrawingData && this.props.DrawingData.ready) {
			this.draw();
		}
	}
	
	componentDidMount() {
		this.viewbox();
		window.addEventListener( 'resize', this.viewbox, false );
	}
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}
	
	viewbox() {
		if ( document.querySelector('#chart-scatter-' + this.props.ChartId) !== null ) {
			var size = {
				"w": document.querySelector( '#chart-scatter-' + this.props.ChartId ).offsetWidth,
				"h": document.querySelector( '#chart-scatter-' + this.props.ChartId ).offsetHeight
			}
			this.setState( { 'size': size }, () => { if ( this.props.DrawingData && this.props.DrawingData.ready ) { this.draw(); } } );
		}
	}
	
	findLineByLeastSquares(values_x, values_y) {
	    var sum_x = 0;
	    var sum_y = 0;
	    var sum_xy = 0;
	    var sum_xx = 0;
	    var count = 0;
	    var x = 0;
	    var y = 0;
	    var v = 0;
	    var values_length = values_x.length;
	
	    if (values_length !== values_y.length) {
	        throw new Error('The parameters values_x and values_y need to have same size!');
	    }
	
	    /*
	     * Nothing to do.
	     */
	    if (values_length === 0) {
	        return [ [], [] ];
	    }
	
	    /*
	     * Calculate the sum for each of the parts necessary.
	     */
	    for (v = 0; v < values_length; v++) {
	        x = values_x[v];
	        y = values_y[v];
	        sum_x += x;
	        sum_y += y;
	        sum_xx += x * x;
	        sum_xy += x * y;
	        count++;
	    }
	
	    /*
	     * Calculate m and b for the formular:
	     * y = x * m + b
	     */
	    var m = (count * sum_xy - sum_x * sum_y) / (count * sum_xx - sum_x * sum_x);
	    var b = (sum_y/count) - (m*sum_x)/count;
	
	    /*
	     * We will make the x and y result line now
	     */
	    var result_values_x = [];
	    var result_values_y = [];
	
	    for (v = 0; v < values_length; v++) {
	        x = values_x[v];
	        y = x * m + b;
	        result_values_x.push(x);
	        result_values_y.push(y);
	    }
	
	    return [result_values_x, result_values_y];
	}
	
	draw() {
		var scaleX = d3.scaleLinear()
            .domain( [ this.props.MinX, this.props.MaxX ] )
            .range( [ 40, ( this.state.size.w - 40 ) ] );
		
		var scaleY = d3.scaleLinear()
            .domain( [ this.props.MinY, this.props.MaxY ] )
            .range( [ ( this.state.size.h - 40 ), 20 ] );
		
		var points = [],
			xVal = [],
			yVal =[],
			regression = [],
			totX = 0,
			totY = 0;
		let point_config = this.state.point_config;
		
		this.props.DrawingData.items.forEach(
			function(p) {
				xVal.push( parseFloat( p.activity ) );
				yVal.push( parseFloat( p.popularity ) );
				points.push({
					"id": p.id,
					"label": p.label,
					"x": scaleX( p.activity ) - (point_config.w / 2),
					"y": scaleY( p.popularity ) - (point_config.h / 2),
				});
				totX += parseFloat( p.activity );
				totY += parseFloat( p.popularity );
			}
		);
		
		let avgX = ( totX / this.props.DrawingData.items.length );
		let avgY = ( totY / this.props.DrawingData.items.length );
		
		regression = this.findLineByLeastSquares( xVal, yVal);
		
		this.setState( {
			"avg": {
				"x": {
					"x1":scaleX(avgX),
					"y1":scaleY(this.props.MinY),
					"x2":scaleX(avgX),
					"y2":scaleY(this.props.MaxY)
				},
				"y": {
					"x1":scaleX(this.props.MinX),
					"y1":scaleY(avgY),
					"x2":scaleX(this.props.MaxX),
					"y2":scaleY(avgY)
				}
			},
			"axis": {
				"x": {
					"x1":scaleX(this.props.MinX),
					"y1":scaleY(this.props.MinY),
					"x2":scaleX(this.props.MaxX),
					"y2":scaleY(this.props.MinY),
					"label": {
						"x": scaleX( this.props.MaxX / 2 ),
						"y": (this.state.size.h - 20)
					}
				},
				"y": {
					"x1":scaleX(this.props.MinX),
					"y1":scaleY(this.props.MinY),
					"x2":scaleX(this.props.MinX),
					"y2":scaleY(this.props.MaxY),
					"label": {
							"x": 30,
						"y": scaleY( this.props.MaxY / 2 )
					}
				}
			},
			"loading": false,
			"points": points,
			"regression": {
				"x1":scaleX(regression[0][0]),
				"y1":scaleY(regression[1][0]),
				"x2":scaleX(regression[0][regression[0].length-1]),
				"y2":scaleY(regression[1][regression[1].length-1])
			}
		} );
		
	}
	
	render() {
		let point_config = this.state.point_config;
		let axis = this.state.axis;
		return (
			<div className="chart-scatter" id={"chart-scatter-" + this.props.ChartId}>
				<svg className="chart-scatter-viz" preserveAspectRatio="xMidYMid meet"viewBox={"0 0 " + this.state.size.w + " " + this.state.size.h}>
					<g className="axis">
						<line x1={this.state.axis.x.x1} y1={this.state.axis.x.y1} x2={this.state.axis.x.x2} y2={this.state.axis.x.y2} className="axis axis-x" strokeWidth="1" stroke="red" />
						<line x1={this.state.axis.y.x1} y1={this.state.axis.y.y1} x2={this.state.axis.y.x2} y2={this.state.axis.y.y2} className="axis axis-y" strokeWidth="1" stroke="red" />
						<text x={this.state.axis.x.label.x} y={this.state.axis.x.label.y} textAnchor="middle" className="label label-x">- {this.props.LabelX} +</text>
						<text x={this.state.axis.y.label.x} y={this.state.axis.y.label.y} textAnchor="middle" className="label label-y" transform={"rotate(-90 " + this.state.axis.y.label.x + " " + this.state.axis.y.label.y + ")"}>- {this.props.LabelY} +</text>
						<path d={"M" + this.state.axis.x.x2 + " " + this.state.axis.x.y2 + "L" + (this.state.axis.x.x2 - 5) + " " + (this.state.axis.x.y2 - 2) + "L" + (this.state.axis.x.x2 - 5) + " " + (this.state.axis.x.y2 + 2) + "Z"} className="arrow arrow-x" />
						<path d={"M" + this.state.axis.y.x2 + " " + this.state.axis.y.y2 + "L" + (this.state.axis.y.x2 - 2) + " " + (this.state.axis.y.y2 + 5) + "L" + (this.state.axis.y.x2 + 2) + " " + (this.state.axis.y.y2 + 5) + "Z"} className="arrow arrow-y" />
					</g>
					<g className="details">
						<line x1={this.state.avg.x.x1} y1={this.state.avg.x.y1} x2={this.state.avg.x.x2} y2={this.state.avg.x.y2} className="avg avg-x" />
						<line x1={this.state.avg.y.x1} y1={this.state.avg.y.y1} x2={this.state.avg.y.x2} y2={this.state.avg.y.y2} className="avg avg-y" />
						<line x1={this.state.regression.x1} y1={this.state.regression.y1} x2={this.state.regression.x2} y2={this.state.regression.y2} className="regression" strokeWidth="1" stroke="red" />
						<text x={this.state.avg.x.x1} y={this.state.avg.x.y2} textAnchor="end" className="label label-avg" transform={"rotate(-90 " + this.state.avg.x.x1 + " " + this.state.avg.x.y2 + ")"}>Attività media</text>
						<text x={this.state.avg.y.x2} y={this.state.avg.y.y1} textAnchor="end" className="label label-avg">Popolarità media</text>
					</g>
					<g className="points">
					{
						this.state.points.map(
							function( point, index ) {
								return (
									<g  key={"point-" + index} className="point-group">
										<rect id={"source-" + point.label} x={point.x} y={point.y} width={point_config.w} height={point_config.h} rx={point_config.rx} ry={point_config.ry} className={"scatter-point " + point.label} title={point.label} transform={"rotate( 45 " + ( point.x + point_config.w / 2 ) + " " + ( point.y + point_config.h / 2 ) + ")" } />
										
										<text x={( point.x > ( axis.x.x2 / 2 ) ) ? point.x : point.x + point_config.w} y={point.y + point_config.h / 2} textAnchor={ ( point.x > ( axis.x.x2 / 2 ) ) ? "end" : "start"} className="label label-over">{point.label.trim()}</text>
									</g>
								);
							}
						)
					}
					</g>
				</svg>
			</div>
		);
	}
}

export default ChartScatter;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/scatter.js